import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectChecklist = (state: RootState) => state.checklist;

export const selectChecklistConfig = (state: RootState) => state.checklist.config;

export const selectQuestionMap = (state: RootState) => state.checklist.questionMap;

export const selectQuestionLocationMap = (state: RootState) => state.checklist.questionLocationMap;

/**
 * Unique section titles in checklist order. Rows only carry the section title
 * (not the id), so the title doubles as the filter value — duplicates collapse
 * into one option.
 */
export const selectSectionTitles = createSelector(
    selectChecklistConfig,
    (config) => {
        const titles = (config?.sections ?? [])
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((section) => section.title);
        return Array.from(new Set(titles));
    }
);

export const selectChecklistLoading = (state: RootState) => state.checklist.loading;

export const selectChecklistError = (state: RootState) => state.checklist.error;

export const selectQuestionById = (questionId: string) => (state: RootState) => {
    return state.checklist.questionMap[questionId];
};

export const selectQuestionLocationById = (questionId: string) => (state: RootState) => {
    return state.checklist.questionLocationMap[questionId];
};
